<ng-container *ngIf="loading; else notificationsTemplate">
  <crm-spinner top="mt-3"></crm-spinner>
</ng-container>

<ng-template #notificationsTemplate>
  <div
    class="lk-eu-informer-list"
    (scroll)="onScrollEnd($any($event.target))">
    <article
      *ngFor="let notification of notifications | orderBy: '-created:date'"
      class="lk-eu-informer-item">
      <div class="lk-eu-informer-item__avatar">
        <crm-user-avatar
          *ngIf="notification.lastNotification?.user"
          [user]="{
            id: notification.lastNotification.user?.id,
            profile: notification.lastNotification.user?.profile
          }"></crm-user-avatar>
        <crm-user-avatar
          *ngIf="notification.lastNotification?.externalUser"
          [user]="{
            id: notification.lastNotification.externalUser?.id,
            profile: notification.lastNotification.externalUser?.profile
          }"></crm-user-avatar>
        <crm-user-avatar
          *ngIf="!notification.lastNotification?.user && !notification.lastNotification?.externalUser"
          [user]="{ id: -1, profile: { id: '00000000-0000-0000-0000-000000000000', name: 'Сервисное Уведомление', file: null } }"></crm-user-avatar>
      </div>

      <div class="lk-eu-informer-item__content">
        <div class="lk-eu-informer-item__head">
          <div class="lk-eu-informer-item__meta">
            <p class="lk-eu-informer-item__author">
              {{
                notification?.lastNotification?.user?.profile?.name ||
                  notification?.lastNotification?.externalUser?.profile?.name ||
                  'Сервисное уведомление'
              }}
            </p>
            <time class="lk-eu-informer-item__time">
              {{ notification.lastNotification?.created | date: 'dd.MM.yyyy HH:mm' }}
            </time>
          </div>
          <p-tag
            *ngIf="notification?.notificationIds?.length > 1"
            [value]="notification?.notificationIds?.length?.toString()"
            styleClass="lk-eu-informer-item__count"
            [rounded]="true"></p-tag>
        </div>

        <p class="lk-eu-informer-item__subject">{{ notification.lastNotification?.subject?.title }}</p>
        <div
          class="lk-eu-informer-item__text break-word"
          [innerHTML]="notification.lastNotification?.text | truncate: 150 | safeHtml"></div>

        <div class="lk-eu-informer-item__actions">
          <crm-button
            *ngIf="notification.lastNotification?.subject?.link"
            label="Перейти"
            icon="pi pi-arrow-right"
            (onClick)="navigateToLink(notification)"
            styleClass="lk-eu-informer-item__action p-button-text p-button-sm"></crm-button>

          <crm-button
            label="Прочитать"
            icon="pi pi-eye"
            styleClass="lk-eu-informer-item__action p-button-text p-button-sm"
            (onClick)="read(notification)"></crm-button>
        </div>
      </div>
    </article>

    <div
      *ngIf="paginationLoading"
      class="lk-eu-informer-list__loader">
      <p-progressSpinner
        [style]="{
          width: '40px',
          height: '40px'
        }"></p-progressSpinner>
    </div>

    <div
      *ngIf="!notifications?.length"
      class="lk-eu-informer-list__empty">
      <crm-no-data [size]="NoDataSize"></crm-no-data>
      <p class="lk-eu-informer-list__empty-text">
        {{ unreadCount === 0 ? 'Нет новых уведомлений' : 'Обновите список, для просмотра непрочитанных уведомлений' }}
      </p>
    </div>
  </div>
</ng-template>
